var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#575756"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7812 21.5C21.875 21.5 21.4688 22 20 22C18.5 22 18.0938 21.5 17.1875 21.5C14.875 21.5 13 23.4062 13 25.7188V26.5C13 27.3438 13.6562 28 14.5 28H25.5C26.3125 28 27 27.3438 27 26.5V25.7188C27 23.4062 25.0938 21.5 22.7812 21.5ZM25.5 26.5H14.5V25.7188C14.5 24.2188 15.6875 23 17.1875 23C17.6562 23 18.375 23.5 20 23.5C21.5938 23.5 22.3125 23 22.7812 23C24.2812 23 25.5 24.2188 25.5 25.7188V26.5ZM20 21C22.4688 21 24.5 19 24.5 16.5C24.5 14.0312 22.4688 12 20 12C17.5 12 15.5 14.0312 15.5 16.5C15.5 19 17.5 21 20 21ZM20 13.5C21.625 13.5 23 14.875 23 16.5C23 18.1562 21.625 19.5 20 19.5C18.3438 19.5 17 18.1562 17 16.5C17 14.875 18.3438 13.5 20 13.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar);
export default __webpack_public_path__ + "static/media/avatar.0e69122f5187608951a1421456961d17.svg";
export { ForwardRef as ReactComponent };